module.exports = __webpack_public_path__ + "img/bildschirmfoto09.cb244e63.png";